
export class Bools {

    init: boolean;
    end: boolean;

    constructor() {
        this.init = false;
        this.end = false;
    }
}

export class DayHours {
    hour: string;
    bools: Bools ;
}



